import {getAxios} from './axios'
import {addAuthTokenData} from './member';
import {responseResolveInterceptor} from 'backend-helpers/interceptors';

export function getProfileAmateurFilms(nick, order) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/profile/amateur_films/',
        method: 'get',
        params: addAuthTokenData({nick, order})
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/profileAmateurFilms.js